import { useContext } from 'react';
import type { SpLogicReferencesApi } from '@sp-api/references-api';
import ApiContext from '../components/ApiProvider/ApiContext';

export default function usePowAttorneyApiClient(): SpLogicReferencesApi {
  const { referencesApi } = useContext(ApiContext);

  return referencesApi;
}
